import React, { useCallback } from 'react';
// eslint-disable-next-line no-restricted-syntax
import { FormattedMessage as ReactIntlFormattedMessage } from 'react-intl-phraseapp';
import { registerElement } from 'services/MessageTranslationsStore';
import { throwCriticalError } from '../../../formData/utils/throwCriticalError';
import { useIntl } from '../../hooks/useIntl';
import { buildFormattedMessageMap } from './buildFormattedMessageMap';

export const FormattedMessage = ({ values, id, children, defaultMessage, tagName, className, ...rest }) => {
    const { getDefaultMessage, formatMessage } = useIntl();

    const mappedValues = buildFormattedMessageMap(values, id);

    const actualDefaultMessage = getDefaultMessage({
        id,
        defaultMessage,
    });

    const props = {
        id,
        defaultMessage: actualDefaultMessage,
        values: mappedValues,
        tagName,
        className,
        ...rest,
    };

    const elementRefCallback = useCallback(
        node => {
            if (node && id) {
                registerElement(node, id, mappedValues);
            }
        },
        [id, mappedValues]
    );

    if (!className) {
        return (
            <span ref={elementRefCallback}>
                <ReactIntlFormattedMessage {...props}>{children}</ReactIntlFormattedMessage>
            </span>
        );
    }

    if (tagName) {
        throwCriticalError(new Error("We don't support TagName prop with className prop"));
        return;
    }

    const message = formatMessage(props, values);

    return (
        <span className={className} ref={elementRefCallback}>
            {children ? children(message) : message}
        </span>
    );
};

FormattedMessage.defaultProps = {
    values: {},
};
